import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./ShitcoinDetail.css";
function ShitcoinDetail() {
  return (
    <section className="shitcoin-detail">
      <Container fluid className="custom-container">
        <Row>
          <Col lg={6} className="pe-lg-5">
            <p>
              Have you invested in an ICO project just to discover you bought a
              shitcoin? sure :-)
            </p>
            <p>
              Have you purchased a coin or token you saw increasing in price and
              the next day lost 90% of its value and discovered you’ve been
              dumped on and now you’re holding a bag of shitcoins?
            </p>
            <p>
              Have you worked your ass off to get on the white list of a hyped
              NFT project and all of a sudden the project team left the Discord
              channel and changed the Telegram to announcement only, leaving you
              pissed off, hating crypto, and holding a PFP piece of shit?
            </p>
            <p>
              Well, we’ve all been there and know this feeling of helplessness
              while feeling the weigth of big bags of shit each time you open
              your crypto wallet.
            </p>
            <p>
              Unfortunately, this type of stuff is happening within the Crypto
              and NFT space and until now, there is very little which can be
              done. Nevertheless, there is some light at the end of your tunnel
              (that’s not a freight train coming your way).
            </p>
          </Col>
          <Col lg={6} className="ps-lg-4">
            <p>How? We thought you would never ask...</p>
            <h4>Welcome to CoinMarketAlert’s ShitCoin Exchange!</h4>
            <p>Yes, you read correctly!</p>
            <h4>You give us your shit - We give you our gold</h4>
            <ol className="list-unstyled mb-3">
              <li>
                {" "}
                <p className="mb-0">How’s it Work?</p>{" "}
              </li>
              <li>
                {" "}
                <p className="mb-0">1 Send us your shitcoins</p>
              </li>
              <li>
                {" "}
                <p className="mb-0">2 Select your (non shitcoin) reward</p>
              </li>
              <li>
                {" "}
                <p className="mb-0">3 Utilize your reward</p>
              </li>
            </ol>
            <p>
              What Rewards?
              <br />
              We’re partnering with various companies and projects within and
              outside the crypto/space to provide us with coupons and discounts
              on their products/services.
            </p>
            <p>
              The goal of our exchange is to grow the customer base and
              community for CoinMarketAlert and our partners and to give
              something back to the crypto space in whole for surviving with so
              many shitcoins.
            </p>
          </Col>
        </Row>
        <p className="text-center mb-0 mt-4">
          We hope our Shitcoin exchange helps you sleep better by not having to
          dwell on your bad decisions anymore.{" "}
        </p>
      </Container>
    </section>
  );
}

export default ShitcoinDetail;
